import { ErrorMessage } from "formik"
import Select from "react-select"
import { useEffect, useRef } from "react"

const DropDownField = (props) => {
  const inputRef = useRef(null)
  const {
    name,
    label = "",
    placeholder = "",
    autofocus = false,
    onChange,
    value,
    options,
  } = props

  useEffect(() => {
    if (inputRef.current && autofocus) {
      inputRef.current.focus()
    }
  }, [inputRef, autofocus])

  return (
    <div className="w-full">
      <label className="ml-1 mb-1 text-sm" htmlFor={name}>
        {label}
      </label>
      <Select
        ref={(el) => {
          inputRef.current = el ?? null
        }}
        isClearable
        isMulti
        isSearchable
        className="z-100"
        id={name}
        name={name}
        noOptionsMessage="No options available"
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={(value) => {
          onChange(name, value)
        }}
      ></Select>
      <ErrorMessage name={name}>
        {(msg) => <p className="text-rose-500 text-xs ml-2 mt-1">{msg}</p>}
      </ErrorMessage>
    </div>
  )
}

export default DropDownField
